import { Box, Grid } from "@mui/material";
import React from "react";
import { EmailField } from "../../../components/FormComponents/EmailField";
import { FormattedPhoneInput } from "../../../components/FormComponents/FormattedPhoneInput";
import { NumericInput } from "../../../components/FormComponents/NumericInput";
import { TextInput } from "../../../components/FormComponents/TextInput";
import { IEmployeeInfo, IPaidMedicalLeaveRequestData } from "../PaidMedicalLeaveRequestData";

interface IPersonalInfoProps {
  onChangeField: <K extends keyof IEmployeeInfo>(
    label: K,
    value: IEmployeeInfo[K]
  ) => void;
  data: IPaidMedicalLeaveRequestData,
  onUpdateEmail: () => void;
  error: Record<string, JSX.Element | string>;
}

export const PersonalInfo: React.FC<IPersonalInfoProps> = ({
  onChangeField,
  data,
  onUpdateEmail,
  error,
}) => (
  <Box sx={{ p: { xs: 0, md: 2 } }}>
    <Grid container spacing={2}>
      <Grid item xs={6} sx={{ p: 0, mb: -2 }}>
        <TextInput
          label="Employee First Name"
          value={data?.employeeInfo?.employeeFirstName || ''}
          onChange={(value) => onChangeField('employeeFirstName', value)}
          maxLength={50}
          required={true}
          error={error?.employeeFirstName}
        />
      </Grid>
      <Grid item xs={6} sx={{ p: 0, mb: -2 }}>
        <TextInput
          label="Employee Last Name"
          value={data?.employeeInfo?.employeeLastName || ''}
          onChange={(value) => onChangeField('employeeLastName', value)}
          maxLength={50}
          required={true}
          error={error?.employeeLastName}
        />
      </Grid>
      <Grid item xs={12} md={10} sx={{ p: 0 }}>
        <NumericInput
          value={data?.employeeInfo.employeeNumber || 0}
          label="Employee #"
          maxLength={6}
          required={true}
          readOnly
        />
      </Grid>
      <Grid item xs={12} md={10}>
        <FormattedPhoneInput
          error={error?.employeePhoneNumber}
          label="Telephone"
          placeholder="Please enter your telephone no."
          value={data?.employeeInfo?.employeePhoneNumber || ''}
          onChange={(value) => onChangeField('employeePhoneNumber', value)}
          required={true}
          maxLength={10}
        />
      </Grid>
      <Grid item xs={12} md={10} sx={{ p: 0 }}>
        <TextInput
          label="Union Status"
          value={
            [data?.employeeInfo.employeeTypeCode ?? '',
            data?.employeeInfo.employeeClassCode ?? '',
            data?.employeeInfo.employeeStatusCode ?? '',
            data?.employeeInfo.employeeHomePortCode ?? '',
            data?.employeeInfo.employeeBoardCode ?? '',
            data?.employeeInfo.employeePlateNumber ?? '']
              .filter(Boolean)
              .join(' ') || ''
          }
          readOnly={true}
          required={true}
        />
      </Grid>
      {!!data.employeeInfo.employeeLocalCode && <Grid item xs={12} md={10} sx={{ p: 0 }}>
        <TextInput
          label="Union Local"
          value={data?.employeeInfo?.employeeLocalCode || ''}
          maxLength={50}
          required={true}
          readOnly={true}
        />
      </Grid>}
      <Grid item xs={12} md={data?.employeeInfo?.employeeEmail ? 10 : 8} sx={{ p: 0 }}>
        <EmailField error={error?.employeeEmail} email={data?.employeeInfo?.employeeEmail || ''} onVerifyEmail={onUpdateEmail} />
      </Grid>
    </Grid>
  </Box>
)
